var styleElement;
export var insertCss = function (css) {
    var _a;
    if (!css) {
        return;
    }
    if (styleElement) {
        return;
    }
    styleElement = document.createElement('style');
    styleElement.setAttribute('type', 'text/css');
    (_a = document.querySelector('head')) === null || _a === void 0 ? void 0 : _a.appendChild(styleElement);
    if (css.charCodeAt(0) === 0xfeff) {
        css = css.substr(1);
    }
    if (styleElement.styleSheet) {
        styleElement.styleSheet.cssText = css;
    }
    else {
        styleElement.textContent = css;
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5zZXJ0Q3NzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3V0aWxzL2luc2VydENzcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFJLFlBQVksQ0FBQTtBQUVoQixNQUFNLENBQUMsSUFBTSxTQUFTLEdBQUcsVUFBQyxHQUFXOztJQUNuQyxJQUFJLENBQUMsR0FBRyxFQUFFO1FBQ1IsT0FBTTtLQUNQO0lBRUQsSUFBSSxZQUFZLEVBQUU7UUFDaEIsT0FBTTtLQUNQO0lBRUQsWUFBWSxHQUFHLFFBQVEsQ0FBQyxhQUFhLENBQUMsT0FBTyxDQUFDLENBQUE7SUFDOUMsWUFBWSxDQUFDLFlBQVksQ0FBQyxNQUFNLEVBQUUsVUFBVSxDQUFDLENBQUE7SUFDN0MsTUFBQSxRQUFRLENBQUMsYUFBYSxDQUFDLE1BQU0sQ0FBQywwQ0FBRSxXQUFXLENBQUMsWUFBWSxFQUFDO0lBRXpELElBQUksR0FBRyxDQUFDLFVBQVUsQ0FBQyxDQUFDLENBQUMsS0FBSyxNQUFNLEVBQUU7UUFDaEMsR0FBRyxHQUFHLEdBQUcsQ0FBQyxNQUFNLENBQUMsQ0FBQyxDQUFDLENBQUE7S0FDcEI7SUFFRCxJQUFJLFlBQVksQ0FBQyxVQUFVLEVBQUU7UUFDM0IsWUFBWSxDQUFDLFVBQVUsQ0FBQyxPQUFPLEdBQUcsR0FBRyxDQUFBO0tBQ3RDO1NBQU07UUFDTCxZQUFZLENBQUMsV0FBVyxHQUFHLEdBQUcsQ0FBQTtLQUMvQjtBQUNILENBQUMsQ0FBQSJ9